import React, {useEffect, useState} from 'react';
import Sidebar from './Sidebar';
import '../../styles/pressReleases.css';
import ImpactReportList from "./ImpactReportList";
import ReportPage from "./ReportPage";
import SurveyList from "./SurveyList";
import TransparencyReportList from "./TransparencyReportList";

type ReportData = {
    title: string;
    date: string;
    pdfSrc: string;
};

const Report = () => {
    const [selectedReport, setSelectedReport] = useState<ReportData | null>(null);

    useEffect(() => {
        document.title = "Report | LinkNYC";
        return () => {
            document.title = "LinkNYC";
        };
    }, []);

    if (selectedReport) {
        return <ReportPage title={selectedReport.title} date={selectedReport.date} pdfSrc={selectedReport.pdfSrc}
                           onBack={() => setSelectedReport(null)}/>;
    }

    return (
        <div className='top-div'>
            <section className='news-section-1'>
                <div className='news-section-div'>
                    <h1>
                        <div style={{backgroundColor: 'white'}}></div>
                        Reports
                    </h1>
                </div>
            </section>
            <section className='news-section-2'>
                <Sidebar/>
                <div>
                    <ImpactReportList onSelect={setSelectedReport}/>
                    <SurveyList onSelect={setSelectedReport}/>
                    <TransparencyReportList onSelect={setSelectedReport}/>
                </div>
            </section>
        </div>
    );
};

export default Report;
